"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Initials = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
/** The TT-Norms font does not appear perfectly centered in the avatar circle. Some padding is necessary to shift the letters down. */
const Initials = (0, _styled.default)("span")`
    padding-top: 0.1em;
`;
exports.Initials = Initials;
//# sourceMappingURL=Initials.js.map